import axios from 'axios'

export default {
  assignDeviceToApp: (appId, mac) => axios.put(`/api/v1/tv-app/device-management/${appId}/${mac}`)
}
